
(function showLoadingDirectiveDefinition() {

    'use strict';

    angular.module('Loading')
        .directive('showLoading', ['$q', function($q) {
            return {
                restrict: 'A',
                link: function($scope, element, attrs) {

                    var div = angular.element('<div></div>');
                    div.addClass('loading-panel');

                    if (attrs.loadingClass) {
                        div.addClass(attrs.loadingClass);
                    }

                    if (attrs.loadingTemplate) {
                        
                        $q.when($scope.$eval(attrs.loadingTemplate))
                          .then(function (template) {
                              div.append(template);
                          });
                    }
                    else if (attrs.loadingText) {
                        var textSpan = angular.element('<span></span>');
                        div.append(textSpan);

                        attrs.$observe('loadingText', function (x) {
                            textSpan.text(x);
                        });
                    }

                    if (element.css('position') === 'static')
                        element.css('position', 'relative');

                    $scope.$watch(attrs.showLoading, function(value) {
                        if (value) {
                            element.append(div);
                        } else {
                            div.remove();
                        }
                    });
                }
            };
        }]);

})();